export const fullFeatureList = [
  {
    id: 1,
    name: "excel",
    description: "",
    active: false,
    site: "ninja",
    attribute_class: "default",
    attribute_type: null,
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    label: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    feature_order: null,
    extra_destination_columns: null,
  },
  {
    id: 3,
    name: "dashboard",
    description: null,
    active: false,
    site: "ninja",
    attribute_class: "default",
    attribute_type: null,
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    label: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    feature_order: null,
    extra_destination_columns: null,
  },
  {
    id: 6,
    name: "runtime_item_groups",
    description: null,
    active: true,
    site: "ninja",
    attribute_class: "default",
    attribute_type: null,
    attribute_sub_type: null,
    attribute_associations: null,
    icon_name: null,
    label: null,
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    feature_order: null,
    extra_destination_columns: null,
  },
  {
    id: 10,
    name: "store_status",
    description: null,
    active: true,
    site: "com",
    attribute_class: "customer",
    attribute_type: "category",
    attribute_sub_type: "flat",
    attribute_associations: [],
    icon_name: null,
    label: "Store Status",
    tree_number_of_levels: null,
    tree_names_of_levels: [],
    feature_order: 1,
    extra_destination_columns: null,
  },
  {
    id: 13,
    name: "csp_participating",
    description: null,
    active: true,
    site: "com",
    attribute_class: "customer",
    attribute_type: "category",
    attribute_sub_type: "flat",
    attribute_associations: ["warehouse"],
    icon_name: null,
    label: "CSP participating",
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    feature_order: 1,
    extra_destination_columns: null,
  },
  {
    id: 14,
    name: "secondary_pos",
    description: null,
    active: true,
    site: ".com",
    attribute_class: "customer",
    attribute_type: "category",
    attribute_sub_type: "flat",
    attribute_associations: null,
    icon_name: null,
    label: "Secondary POS",
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    feature_order: 1,
    extra_destination_columns: [],
  },
  {
    id: 15,
    name: "store_status_log",
    description: null,
    active: true,
    site: "com",
    attribute_class: "customer",
    attribute_type: "one-to-one",
    attribute_sub_type: "flat",
    attribute_associations: null,
    icon_name: null,
    label: "Store Status Log",
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    feature_order: -1,
    extra_destination_columns: null,
  },

  {
    id: 16,
    name: "daily_patron_points_api",
    description: null,
    active: true,
    site: "com",
    attribute_class: "customer",
    attribute_type: "one-to-one",
    attribute_sub_type: "flat",
    attribute_associations: null,
    icon_name: null,
    label: "Daily Patron Points",
    tree_number_of_levels: null,
    tree_names_of_levels: null,
    feature_order: -1,
    extra_destination_columns: null,
  },

  // these were only on ninja but are in the data and with custom transfer routines
  //   {
  //     id: 9,
  //     name: "Each UPC",
  //     description: null,
  //     active: false,
  //     site: "ninja",
  //     attribute_class: "item",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: "each_upc",
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 12,
  //     name: "csp_interest",
  //     description: null,
  //     active: false,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "category",
  //     attribute_sub_type: "flat",
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: "csp_interest",
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: 1,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 16,
  //     name: "rewards",
  //     description: "compliance engine",
  //     active: false,
  //     site: "ninja",
  //     attribute_class: "default",
  //     attribute_type: null,
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 18,
  //     name: "wam_chain_id",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 20,
  //     name: "wam_store_id",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 21,
  //     name: "patron_point_store_ids",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 23,
  //     name: "wam_primary_warehouse_id",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 26,
  //     name: "wam_primary_warehouse_name",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 27,
  //     name: "wam_primary_distributor_id",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 28,
  //     name: "wam_pirmary_distributor_name",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 29,
  //     name: "wam_rep_name",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 30,
  //     name: "wam_rep_id",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 31,
  //     name: "wam_store_zip",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 32,
  //     name: "wam_store_state",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 33,
  //     name: "wam_store_city",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 34,
  //     name: "wam_store_address",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 35,
  //     name: "wam_store_name",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 38,
  //     name: "wam_store_category",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
  //   {
  //     id: 39,
  //     name: "point_of_sale_system",
  //     description: null,
  //     active: true,
  //     site: "ninja",
  //     attribute_class: "customer",
  //     attribute_type: "one-to-one",
  //     attribute_sub_type: null,
  //     attribute_associations: null,
  //     icon_name: null,
  //     label: null,
  //     tree_number_of_levels: null,
  //     tree_names_of_levels: null,
  //     feature_order: null,
  //     extra_destination_columns: null,
  //   },
];
export const storeAttrOptions = [];
export const storeGroupByOptions = [];
export const itemAttrOptions = [];
export const storeFilterOptions = [];
export const itemGroupColumnOptions = [];
export const runtimeItemGroupFilterOptions = [];
